const cn = {
    protect_free: '技术保护',
    protect_trial: '技术保护',
    protect_commercial_old: '技术保护',
    protect_commercial: '技术保护',
    material_trial: '新材料',
    material_commercial_old: '新材料',
    material_commercial: '新材料',
    material_commercial_rapid_search: '材料速研版',
    air_free: 'Eureka 基础版',
    air_trial: '技术方案',
    air_commercial: '技术方案',
    unlock_skills_trial: 'Eureka 试用版',
    insights_trial: '研发情报',
    insights_commercial: '研发情报',
    air_commercial_professional_edition: '研发专业版',
    air_commercial_professional_edition_trial: '研发专业版',
    air_commercial_navigator_edition: '研发领航版',
    air_commercial_navigator_edition_trial: '研发领航版',

    ls_trial: '生物医药 (试用)',
    ls_trial_five: '生物医药',
    ls_commercial: '生物医药',
    ls_commercial_share: '生物医药专业版',
    ls_commercial_share_trial: '生物医药 (试用)',
    ls_trial_hiro: '生物医药百科问答 & 文档精读 (试用)',
    ls_trial_hiro_full: '生物医药百科问答 & 文档精读 (试用)',
    ls_commercial_hiro: '生物医药百科问答 & 文档精读',
    ls_commercial_pharma: '生物医药百科问答 & 文档精读',
    ls_commercial_draft: '马库什权要撰写 ',
    ls_commercial_antibody: '优选抗体推荐',
    ls_commercial_launch: '药物知产报告',
    ls_commercial_agent: '生物医药增强包',

    ip_commercial: '知识产权',
    ip_trial_novelty_drafting: '知识产权',
    ip_trial_infringement: '防侵权检索',
    ip_trial_novelty: '查新检索',
    ip_commercial_specification_cnipa: '专利说明书撰写(CNIPA)',
    ip_commercial_specification_uspto: '专利说明书撰写(USPTO)',
    ip_commercial_specification_epo: '专利说明书撰写(EPO)',
    ip_commercial_design_infringement: '外观防侵权检索',
    ip_commercial_infringement: '防侵权检索',
    ip_commercial_disclosure: '技术交底书撰写',
    ip_commercial_translation: '专利翻译',
    ip_commercial_novelty: '查新检索',
    ip_commercial_novelty_draft: 'AI查新&撰写',
    ip_commercial_draft: 'AI撰写',
};

const en = {
    protect_free: 'Eureka Search',
    protect_trial: 'Eureka Search',
    protect_commercial_old: 'Eureka Search',
    protect_commercial: 'Eureka Search',
    material_trial: 'Eureka Materials',
    material_commercial_old: 'Eureka Materials',
    material_commercial: 'Eureka Materials',
    material_commercial_rapid_search: 'Materials Express',
    air_free: 'Eureka Basic',
    air_trial: 'Eureka Ideas',
    air_commercial: 'Eureka Ideas',
    unlock_skills_trial: 'Eureka Trial',
    insights_trial: 'Eureka Scout',
    insights_commercial: 'Eureka Scout',
    air_commercial_professional_edition: 'R&D Professional Edition',
    air_commercial_professional_edition_trial: 'R&D Professional Edition',
    air_commercial_navigator_edition: 'R&D Pilot Edition',
    air_commercial_navigator_edition_trial: 'R&D Pilot Edition',

    ls_trial: 'Life Sciences (Trial)',
    ls_trial_five: 'Life Sciences',
    ls_commercial: 'Life Sciences',
    ls_commercial_share: 'Life Sciences Professional',
    ls_commercial_share_trial: 'Life Sciences (Trial)',
    ls_trial_hiro: 'Life Sciences - PIA & PDA (Trial)',
    ls_trial_hiro_full: 'Life Sciences - PIA & PDA (Trial)',
    ls_commercial_hiro: 'Life Sciences - PIA & PDA',
    ls_commercial_pharma: 'Life Sciences - PIA & PDA',
    ls_commercial_draft: 'Life Sciences - MCD',
    ls_commercial_antibody: 'Life Sciences - ATP',
    ls_commercial_launch: 'Life Sciences - PCIE',
    ls_commercial_agent: 'Life Sciences Usage Package',

    ip_commercial: 'IP',
    ip_trial_novelty_drafting: 'IP',
    ip_trial_infringement: 'IP - FTO Search',
    ip_trial_novelty: 'IP - Novelty Search',
    ip_commercial_specification_cnipa: 'IP - Patent Drafting (CNIPA)',
    ip_commercial_specification_uspto: 'IP - Patent Drafting (USPTO)',
    ip_commercial_specification_epo: 'IP - Patent Drafting (EPO)',
    ip_commercial_design_infringement: 'IP - Design FTO Search',
    ip_commercial_infringement: 'IP - FTO Search',
    ip_commercial_disclosure: 'IP - Invention Disclosure',
    ip_commercial_translation: 'IP - Patent Translation',
    ip_commercial_novelty: 'IP - Novelty Search',
    ip_commercial_novelty_draft: 'IP - AI Novelty Search & AI Drafting',
    ip_commercial_draft: 'IP - AI Drafting',
};

const tw = {
    protect_free: '科技保護',
    protect_trial: '科技保護',
    protect_commercial_old: '科技保護',
    protect_commercial: '科技保護',
    material_trial: '新材料',
    material_commercial_old: '新材料',
    material_commercial: '新材料',
    material_commercial_rapid_search: '材料速研版',
    air_free: 'Eureka 基礎版',
    air_trial: '科技方案',
    air_commercial: '科技方案',
    unlock_skills_trial: 'Eureka 試用版',
    insights_trial: '研發情報',
    insights_commercial: '研發情報',
    air_commercial_professional_edition: '研發專業版',
    air_commercial_professional_edition_trial: '研發專業版',
    air_commercial_navigator_edition: '研發領航版',
    air_commercial_navigator_edition_trial: '研發領航版',

    ls_trial: '生物醫藥 (試用)',
    ls_trial_five: '生物醫藥',
    ls_commercial: '生物醫藥',
    ls_commercial_share: '生物醫藥專業版',
    ls_commercial_share_trial: '生物醫藥 (試用)',
    ls_trial_hiro: '生物醫藥百科問答 & 文檔精讀 (試用)',
    ls_trial_hiro_full: '生物醫藥百科問答 & 文檔精讀 (試用)',
    ls_commercial_hiro: '生物醫藥百科問答 & 文檔精讀',
    ls_commercial_pharma: '生物醫藥百科問答 & 文檔精讀',
    ls_commercial_draft: '馬庫什權要撰寫 ',
    ls_commercial_antibody: '優選抗體推薦',
    ls_commercial_launch: '藥物知產報告',
    ls_commercial_agent: '生物醫藥增強包',

    ip_commercial: '知識產權',
    ip_trial_novelty_drafting: '知識產權',
    ip_trial_infringement: '防侵權檢索',
    ip_trial_novelty: '查新檢索',
    ip_commercial_specification_cnipa: '專利說明書撰寫(CNIPA)',
    ip_commercial_specification_uspto: '專利說明書撰寫(USPTO)',
    ip_commercial_specification_epo: '專利說明書撰寫(EPO)',
    ip_commercial_design_infringement: '外觀防侵權檢索',
    ip_commercial_infringement: '防侵權檢索',
    ip_commercial_disclosure: '技術交底書撰寫',
    ip_commercial_translation: '專利翻譯',
    ip_commercial_novelty: '查新檢索',
    ip_commercial_novelty_draft: 'AI查新&撰寫',
    ip_commercial_draft: 'AI撰寫',
};

const jp = {
    protect_free: '計画保護',
    protect_trial: '計画保護',
    protect_commercial_old: '計画保護',
    protect_commercial: '計画保護',
    material_trial: '材料科学',
    material_commercial_old: '材料科学',
    material_commercial: '材料科学',
    material_commercial_rapid_search: '材料クイック研究版',
    air_free: 'Eureka 基礎版',
    air_trial: '研究開発計画',
    air_commercial: '研究開発計画',
    unlock_skills_trial: 'Eureka 体験版',
    insights_trial: 'Eureka Scout',
    insights_commercial: 'Eureka Scout',
    air_commercial_professional_edition: '研究開発プロフェッショナル版',
    air_commercial_professional_edition_trial: '研究開発プロフェッショナル版',
    air_commercial_navigator_edition: '研究開発ナビゲーター版',
    air_commercial_navigator_edition_trial: '研究開発ナビゲーター版',

    ls_trial: 'ライフサイエンス (試用)',
    ls_trial_five: 'ライフサイエンス',
    ls_commercial: 'ライフサイエンス',
    ls_commercial_share: 'ライフサイエンス プロフェッショナル版',
    ls_commercial_share_trial: 'ライフサイエンス (試用)',
    ls_trial_hiro: 'ライフサイエンス百科Q&A & 文書精読 (試用)',
    ls_trial_hiro_full: 'ライフサイエンス百科Q&A & 文書精読 (試用)',
    ls_commercial_hiro: 'ライフサイエンス百科Q&A & 文書精読',
    ls_commercial_pharma: 'ライフサイエンス百科Q&A & 文書精読',
    ls_commercial_draft: 'マーカッシュ権利要件作成',
    ls_commercial_antibody: '最適抗体推薦',
    ls_commercial_launch: '医薬知財レポート',
    ls_commercial_agent: 'ライフサイエンス 拡張パック',

    ip_commercial: 'IP',
    ip_trial_novelty_drafting: 'IP',
    ip_trial_infringement: 'IP - FTO Search',
    ip_trial_novelty: 'IP - Novelty Search',
    ip_commercial_specification_cnipa: 'IP - Patent Drafting (CNIPA)',
    ip_commercial_specification_uspto: 'IP - Patent Drafting (USPTO)',
    ip_commercial_specification_epo: 'IP - Patent Drafting (EPO)',
    ip_commercial_design_infringement: 'IP - Design FTO Search',
    ip_commercial_infringement: 'IP - FTO Search',
    ip_commercial_disclosure: 'IP - Invention Disclosure',
    ip_commercial_translation: 'IP - Patent Translation',
    ip_commercial_novelty: 'IP - Novelty Search',
    ip_commercial_novelty_draft: 'IP - AI Novelty Search & AI Drafting',
    ip_commercial_draft: 'IP - AI Drafting',
};

export {
    cn, en, tw, jp,
};
